import { NgModule } from '@angular/core';
import { PersistenceService } from '../services/persistence.service';
/**
 * The module for the persistence framework.  This will register the PersistenceService
 * as a provider and export it.
 *
 * @export
 * \@class AngularPersistenceModule
 *
 * @author Scott O'Bryan
 * \@since 1.0
 */
export var PersistenceModule = (function () {
    function PersistenceModule() {
    }
    PersistenceModule.decorators = [
        { type: NgModule, args: [{
                    providers: [PersistenceService]
                },] },
    ];
    /** @nocollapse */
    PersistenceModule.ctorParameters = function () { return []; };
    return PersistenceModule;
}());
function PersistenceModule_tsickle_Closure_declarations() {
    /** @type {?} */
    PersistenceModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    PersistenceModule.ctorParameters;
}
//# sourceMappingURL=persistence.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-persistence/src/modules/persistence.module.js
// module id = 867
// module chunks = 3